export default (options) => {
  return {
    event: 'acquisitionAds',
    bannerMessage: options.bannerMessage,
    bannerPromo: options.bannerPromo,
    Channel: 'MYB',
    clubpremierID: options.clubpremierID,
    coBrandedCard: options.coBrandedCard,
    cobrandedCardsNumber: options.cobrandedCardsNumber,
    country: options.country,
    gender: options.gender,
    PNR: options.PNR,
    storeFront: options.storeFront,
    ticketNumber: options.ticketNumber,
    tierLvl: options.tierLvl,
  };
};